import classNames from "classnames"
import { AlertConfigurationModule } from "../types"
import Color from "@/components/AlertSettingForms/Color"
import Message from "@/components/AlertSettingForms/Message"
import Sound from "@/components/AlertSettingForms/Sound"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { AlertEmailMessage } from "@/types/alert"
import { AlertConfigurationForm } from "@/types/alertConfigurations"

type CommonSettingsProps = {
   disabled?: boolean
   loading: boolean
   updatingModule: string
   alarmName: string
   soundClip: number
   soundFrequency: string
   colorCard: string
   colorTypeface: string
   emailMessage?: AlertEmailMessage
   handleSave: (
      state: Partial<AlertConfigurationForm>,
      configurationModule: AlertConfigurationModule
   ) => void
}

function CommonSettings({
   disabled = false,
   loading,
   updatingModule,
   alarmName,
   soundClip,
   soundFrequency,
   colorCard,
   colorTypeface,
   emailMessage,
   handleSave,
}: CommonSettingsProps) {
   return (
      <GridItem
         size={12}
         className={classNames({
            "alert-setting-detail__section--disabled": disabled,
         })}
      >
         <Grid flexWrap="nowrap">
            <Sound
               loading={
                  loading && updatingModule === AlertConfigurationModule.SOUND
               }
               alarmName={alarmName}
               soundFileId={soundClip}
               soundFrequency={soundFrequency}
               onSave={(state) =>
                  handleSave({ sound: state }, AlertConfigurationModule.SOUND)
               }
            />

            <Color
               loading={
                  loading && updatingModule === AlertConfigurationModule.COLOR
               }
               colorCard={colorCard}
               colorTypeface={colorTypeface}
               onSave={(state) =>
                  handleSave({ color: state }, AlertConfigurationModule.COLOR)
               }
            />

            <Message
               loading={
                  loading &&
                  updatingModule === AlertConfigurationModule.EMAIL_MESSAGE
               }
               message={emailMessage}
               onSave={(state) =>
                  handleSave(state, AlertConfigurationModule.EMAIL_MESSAGE)
               }
            />

            {/* <GridItem size={3}>
                  <AlertMessageSettings
                     messageType={MessageType.TEXT}
                     icon="message"
                     title="Text messaging"
                     form={createMessageForm(form.textMessage)}
                     onSave={(state) =>
                        handleSave(
                           { textMessage: createTextMessageData(state) },
                           AlertConfigurationModule.TEXT_MESSAGE
                        )
                     }
                  />
               </GridItem> */}

            {/* <DataSharing
                  dataSharingForm={dataSharing}
                  loading={
                     loading &&
                     updatingModule === AlertConfigurationModule.DATA_SHARING
                  }
                  onSave={(state) =>
                     handleSave(
                        { dataSharing: state },
                        AlertConfigurationModule.DATA_SHARING
                     )
                  }
               /> */}
         </Grid>
      </GridItem>
   )
}

export default CommonSettings
